<template>
	<div class="workbenchEnterpriseDetails">
		<div class="indexcenterpage">
			<leftnav class="fl"></leftnav>
			<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
				<govheader></govheader>
				<div class="index_left_centerpage">
					<!-- 上 -->
					<div class="workbench_details_top oh whitebox">
						<!-- 企业详情开始 -->
						<div class="enterprisedetailsbox whitebox fl">
							<div class="entitle oh">
								<h3 class="fl">{{ title }}</h3>
								<span :class="state == 1 ? 'cx-span entitle_btn' : 'cx-span cur-span'">存续</span>
								<!-- <span :class="state == 2 ? 'entitle_btn' : ''">有意向</span> -->
								<div class="pl-3"><evaluationProject class="fr" :companyinfo="cusinfo"></evaluationProject></div>
							</div>

							<div class="enterprisedetails project">

								<addProject :type="2" @postCusInfo="postCusInfo" :isEdit="!cusinfo.edit" :cusid="cusid"
									:projectData="project">
								</addProject>
							</div>
						</div>
						<!-- 企业详情结束 -->

						<div class="fl clear-both whitebox">
							<div class="enterprisedetails  oh py-2" style="width: 600px;margin-top: 80px;">
								<table border="0" cellspacing="0" cellpadding="0">
									<tr>
										<td><i>注册资本</i> <br /><em>{{ companyinfo.regCapital }}</em></td>
										<td><i>组织机构代码</i><br /><em>{{ companyinfo.orgCode }}</em></td>

									</tr>
									<tr>
										<td><i>员工人数</i><br /><em>{{ companyinfo.insurePerson }}</em></td>
										<td><i>企业类型</i><br /><em>{{ companyinfo.type }}</em></td>
									</tr>
									<tr>
										<td><i>注册号</i><br /><em>{{ companyinfo.regNo }}</em></td>
										<td><i>纳税人识别号</i><br /><em>{{ companyinfo.taxNo }}</em></td>
									</tr>
									<tr>
										<td><i>行业分类</i><br /><em>{{ companyinfo.industry }}</em></td>
										<td v-if="realController.length > 0">
											<i>疑似实际控制人</i><br /><em>{{ realController[0].title }}</em>
										</td>

									</tr>
									<tr>
										<td v-if="realController.length > 0">
											<i>总股权比例</i><br /><em>{{ realController[0].proportion }}</em>
										</td>
									</tr>
									<tr v-if="companyinfo.notionlist.length != 0">
										<td colspan="3"><i>所属概念</i><br /><em><span v-show="i < 10"
													v-for="(item, i) in companyinfo.notionlist" :key="item.id"
													@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'workbench')">{{
														item.name }}</span></em>
										</td>
									</tr>
									<tr>
										<td colspan="3"><i>企业画像</i><br /><em style="width: 90%;"><span v-show="i < 18"
													:key="item.id" v-for="(item, i) in companyinfo.taglist"
													@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name, 'workbench')">{{
														item.name }}</span></em>
										</td>
									</tr>
								</table>
								<span class="curp fr mr-4"
									@click="routerblank('/enterprises?id=' + companyinfo.stockCode)">查看企业详情 ></span>
							</div>

						</div>

					</div>
					<!-- 上 结束 -->
					 <el-dialog class="localChain" custom-class="initiate_box_dialog" title="备注" center :visible.sync="isInitiate" top="25vh">
						<div class="initiate_box"> 
								<el-row class="mb-1" >
								<el-col :span="24">
									<p>{{temDialogText}}</p>
								</el-col>
							</el-row>
						</div>
					</el-dialog>
					<!-- 中 -->
					<div class="oh">
						<div class="workbench_details_middle fl widthPC-60 border">
							<div class="enterprisedetailsbox whitebox oh">
								<div class="oh">
									<h3 class="fl">记录</h3>
									<!-- <span class="fr add" v-show="follow == 1"
									@click="gjframe = true; getParameter()">添加</span> -->
									<el-button v-show="follow == 1" class="fr mr-2" type="primary"
										@click="gjframe = true; getParameter()">添加记录</el-button>
									<!-- <span class="fr add" v-show="follow == 2"
									@click="dbframe = true; getmangerlist()">添加</span> -->
									<el-button v-show="follow == 2" class="fr mr-2" type="primary"
										@click="dbframe = true; getmangerlist()">添加待办</el-button>

								</div>
								<ul class="fl follow_list_ul">
									<li @click="follow = 1" :class="follow == 1 ? 'follow_curt' : ''">跟进记录</li>
									<li @click="follow = 2; gettodolist();" :class="follow == 2 ? 'follow_curt' : ''">
										待办记录
									</li>
									<!-- <li @click="follow = 3,getPushLogs();" :class="follow == 3 ? 'follow_curt' : ''">推送撤回</li> -->
									
								</ul>
								<!-- 跟进纪录表格开始 -->
								<div class="follow_list_tablebox fl">
									<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="follow == 1">
										<tr>
											<th class="time">录入时间 </th>
											<th class="time">跟进时间</th>
											<th>跟进状态</th>
											<th>联系人</th>
											<th>负责人</th>
											<th>备注</th>
											<th>操作</th>
										</tr>
										<tr v-for="(item, i) in tracklist" :key="'tark' + i">
											<td class="time">{{ item.createTime }}</td>
											<td class="time">{{ item.contactTime }}</td>
											<td>
												<span>{{ trackStatusTurnLabel(item.trackStatus) }}</span>
											</td>
											<td>{{ item.contactName }}</td>
											<td>{{ item.managerName }}</td>
											<td class="summary-td cur-pointer bluefont">
												<span v-if="item.remark != ''" @click="initiatePopup(item.remark)">{{ item.remark }}</span>
												<span v-if="item.remark == ''">暂无</span>
											</td>
											<td class="follow_edit"><span
													@click="editgjframe = true; trackid = item.id; getParameter(); getTrackdetail(item.id)">修改</span>
												| <span @click="trackid = item.id; open2()">删除</span></td>
										</tr>
									</table>
									
									<!-- 添加跟进纪录弹框 -->
									<div class="framebgbox" v-show="gjframe">
										<div class="framebox">
											<div class="frame">
												<h4>添加跟进记录</h4>
												<table border="0" cellspacing="0" cellpadding="0">
													<tr>
														<td>公司名称</td>
														<td>
															<span style="margin-left: 10px;">{{ companyinfo.title
															}}</span>
														</td>
													</tr>
													<tr>
														<td>跟进时间</td>
														<td>
															<el-date-picker v-model="trackTime" type="datetime"
																placeholder="选择日期时间" @change="dateFormat(3, trackTime)">
															</el-date-picker>
														</td>
													</tr>
													<tr>
														<td>跟进状态</td>
														<td>
															<el-select v-model="trackStatusvalue" placeholder="请选择">
																<el-option v-for="item in trackStatusoptions"
																	:key="item.value" :label="item.label"
																	:value="item.value">
																</el-option>
															</el-select>
														</td>
													</tr>
													<tr>
														<td>联系人</td>
														<td>
															<el-select v-model="contactId" placeholder="请选择">
																<el-option v-for="item in contactoptions" :key="item.id"
																	:label="item.contactName"
																	:value="item.id"></el-option>
															</el-select>
														</td>
													</tr>
													<tr>
														<td>备 注</td>
														<td>
															<textarea v-model="addtrackremark"></textarea>
														</td>
													</tr>
													<tr>
														<td></td>
														<td colspan="2"
															style="text-align: center;color: red;font-size: 14px;"
															v-show="erromsg != ''">{{ erromsg }}</td>
													</tr>
												</table>
												<div class="frame_btn">
													<span class="frame_cancel" @click="gjframe = false">取消</span>
													<span class="frame_determine"
														@click="addtrackfun(0, cusid)">确定</span>
												</div>
											</div>
										</div>
									</div>
									<!-- 添加跟进纪录弹框end -->
									<!-- 修改跟进纪录弹框 -->
									<div class="framebgbox" v-show="editgjframe">
										<div class="framebox">
											<div class="frame">
												<h4>修改跟进记录</h4>
												<table border="0" cellspacing="0" cellpadding="0">
													<tr>
														<td>公司名称</td>
														<td>
															<span style="margin-left: 10px;">{{ companyinfo.title
															}}</span>
														</td>
													</tr>
													<tr>
														<td>跟进时间</td>
														<td>
															<el-date-picker v-model="trackTime" type="datetime"
																placeholder="选择日期时间" @change="dateFormat(3, trackTime)">
															</el-date-picker>
														</td>
													</tr>
													<tr>
														<td>跟进状态</td>
														<td>
															<el-select v-model="trackStatusvalue" placeholder="请选择">
																<el-option v-for="item in trackStatusoptions"
																	:key="item.value" :label="item.label"
																	:value="item.value">
																</el-option>
															</el-select>
														</td>
													</tr>
													<tr>
														<td>联系人</td>
														<td>
															<el-select v-model="contactId" placeholder="请选择">
																<el-option v-for="item in contactoptions" :key="item.id"
																	:label="item.contactName" :value="item.id">
																</el-option>
															</el-select>
														</td>
													</tr>
													<tr>
														<td>备 注</td>
														<td>
															<textarea v-model="addtrackremark"></textarea>
														</td>
													</tr>
													<tr>
														<td></td>
														<td colspan="2"
															style="text-align: center;color: red;font-size: 14px;"
															v-show="erromsg != ''">{{ erromsg }}</td>
													</tr>
												</table>
												<div class="frame_btn">
													<span class="frame_cancel" @click="editgjframe = false">取消</span>
													<span class="frame_determine"
														@click="addtrackfun(trackid, cusid)">确定</span>
												</div>
											</div>
										</div>
									</div>
									<!-- 修改跟进纪录弹框end -->
									<!-- 跟进纪录结束 -->
									<!-- 待办纪录 -->
									<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="follow == 2">
										<tr>
											<th class="time">录入时间 </th>
											<th class="time">待办时间</th>
											<th>提前提醒</th>
											<th>联系人</th>
											<th>负责人</th>
											<th>备注</th>
											<th>操作</th>
										</tr>
										<tr v-for="item in todolist" :key="item.id">
											<td class="time">{{ item.createTime }}</td>
											<td class="time">{{ item.todoTime }}</td>
											<td>提前{{ item.notifyTime }}小时</td>
											<td>{{ item.contactName }}</td>
											<td>{{ item.managerName }}</td>
											<td class="summary-td cur-pointer bluefont">
												<span v-if="item.remark != ''" @click="initiatePopup(item.remark)">{{ item.remark }}</span>
												<span v-if="item.remark == ''">暂无</span>
											</td>
											<td class="follow_edit"><span
													@click="editdbframe = true; todoid = item.id; getmangerlist(); getTododetail(item.id)">修改</span>
												|
												<span @click="todoid = item.id; open()">删除</span>
											</td>
										</tr>
									</table>
									<!-- 添加弹框 -->
									<div class="framebgbox" v-show="dbframe">
										<div class="framebox">
											<div class="frame">
												<h4>添加待办记录</h4>
												<table border="0" cellspacing="0" cellpadding="0">
													<tr>
														<td>公司名称</td>
														<td>
															<span style="margin-left: 10px;">{{ companyinfo.title
															}}</span>
														</td>
													</tr>
													<tr>
														<td>待办时间</td>
														<td>
															<el-date-picker v-model="todoTime" type="datetime"
																placeholder="选择日期时间" @change="dateFormat(1, todoTime)">
															</el-date-picker>
														</td>
													</tr>
													<tr>
														<td>提醒时间</td>
														<td>
															<el-date-picker v-model="notifyTime" type="datetime"
																placeholder="选择日期时间"
																@change="dateFormat(2, notifyTime)">
															</el-date-picker>
														</td>
													</tr>
													<tr>
														<td>联系人</td>
														<td>
															<el-select v-model="contactId" placeholder="请选择">
																<el-option v-for="item in contactoptions" :key="item.id"
																	:label="item.contactName" :value="item.id">
																</el-option>
															</el-select>
														</td>
													</tr>
													<tr>
														<td>备 注</td>
														<td>
															<textarea v-model="dbremark"></textarea>
														</td>
													</tr>
													<tr>
														<td></td>
														<td colspan="2"
															style="text-align: center;color: red;font-size: 14px;"
															v-show="erromsg != ''">{{ erromsg }}</td>
													</tr>
												</table>
												<div class="frame_btn">
													<span class="frame_cancel" @click="dbframe = false">取消</span>
													<span class="frame_determine"
														@click="addtodofun(0, cusid)">确定</span>
												</div>
											</div>
										</div>
									</div>
									<!-- 添加待办纪录弹框end -->
									<!-- 修改待办纪录弹框 -->
									<div class="framebgbox" v-show="editdbframe">
										<div class="framebox">
											<div class="frame">
												<h4>修改待办记录</h4>
												<table border="0" cellspacing="0" cellpadding="0">
													<tr>
														<td>公司名称</td>
														<td>
															<span style="margin-left: 10px;">{{ companyinfo.title
															}}</span>
														</td>
													</tr>
													<tr>
														<td>待办时间</td>
														<td>
															<el-date-picker v-model="todoTime" type="datetime"
																placeholder="选择日期时间" @change="dateFormat(1, todoTime)">
															</el-date-picker>
														</td>
													</tr>
													<tr>
														<td>提醒时间</td>
														<td>
															<el-date-picker v-model="notifyTime" type="datetime"
																placeholder="选择日期时间"
																@change="dateFormat(2, notifyTime)">
															</el-date-picker>
														</td>
													</tr>
													<tr>
														<td>联系人</td>
														<td>
															<el-select v-model="contactId" placeholder="请选择">
																<el-option v-for="item in contactoptions" :key="item.id"
																	:label="item.contactName" :value="item.id">
																</el-option>
															</el-select>
														</td>
													</tr>
													<tr>
														<td>备 注</td>
														<td>
															<textarea v-model="dbremark"></textarea>
														</td>
													</tr>
													<tr>
														<td></td>
														<td colspan="2"
															style="text-align: center;color: red;font-size: 14px;"
															v-show="erromsg != ''">{{ erromsg }}</td>
													</tr>
												</table>
												<div class="frame_btn">
													<span class="frame_cancel" @click="editdbframe = false">取消</span>
													<span class="frame_determine"
														@click="addtodofun(todoid, cusid)">确定</span>
												</div>
											</div>
										</div>
									</div>
									<!-- 修改待办弹框end -->

									<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-show="follow == 3">
										<tr>
											<th class="time">录入时间 </th>
											<th class="time">联系时间</th>
											<th>负责人</th>
											<th>状态</th>
											<th>备注</th>
											<!-- <th>操作</th> -->
										</tr>
										<tr v-for="item in pushLogs.trackList" :key="item.id">
											<td class="time">{{ item.createTime }}</td>
											<td class="time">{{ item.contactTime }}</td>
											<td>{{ item.managerName }}</td>
											<td>{{ item.statusText }}</td>
											<td class="summary-td cur-pointer bluefont">
												<span v-if="item.remark != ''" @click="initiatePopup(item.remark)">{{ item.remark }}</span>
												<span v-if="item.remark == ''">暂无</span>
											</td>
											<!-- <td class="follow_edit"><span
													@click="editdbframe = true; todoid = item.id; getmangerlist(); getTododetail(item.id)">修改</span>
												|
												<span @click="todoid = item.id; open()">删除</span>
											</td> -->
										</tr>
									</table>
								</div>
								<!-- 待办纪录结束 -->

								<!-- 推送撤回记录 -->
								 <!-- <el-card>
									<el-row>
										<el-col  :span="12">标题:</el-col >
										<el-col  :span="12">{{ pushLogs.title}}</el-col >
									</el-row>
									<el-row>
										<el-col  :span="12">标题:</el-col >
										<el-col  :span="12">{{ pushLogs.title}}</el-col >
									</el-row>
								 </el-card> -->
								 
							</div>
							<!-- 纪录表格结束 -->

						</div>
						<div class="fl widthPC-40">
							<!-- 联系人开始 -->
							<div class="contacts whitebox " v-show="cnav == false">
								<div class="oh">
									<h3 class="fl">联系人</h3>
									<div class="fr mr-4 mt-2"><el-button type="primary"
											@click="contactframe = true">添加联系人</el-button></div>
								</div>
								<div class="contacts_list oh">
									<ul class=" contacts_list_ul oh">
										<!-- <li v-for="(item,i) in contactlist" @click="getcontactdetail(item.id);contactnav=i" :class="contactnav==i?'curlibg':''" >{{item.contactName}}</li> -->
										<li v-for="(item, i) in contactlist"
											@click="contactnav = i; getcontactdetail(item.id);" :key="item.id"
											:class="contactnav == i ? 'curlibg' : ''">{{ item.contactName }}</li>
									</ul>
									<table border="0" cellspacing="0" cellpadding="0" class="fl">
										<tr>
											<td><i>姓名</i><em>{{ contactdetails.contactName }}</em></td>
											<td><i>性别</i><em><span v-if="contactdetails.gender == 1">男</span><span
														v-if="contactdetails.gender == 2">女</span><span
														v-if="contactdetails.gender == 0">未知</span></em></td>
										</tr>
										<tr>
											<td><i>部门</i><em>{{ dname(contactdetails.departmentId || '') }}</em></td>
											<td><i>职位</i><em>{{ contactdetails.position }}</em></td>
										</tr>
										<tr>
											<td><i>手机</i><em>{{ contactdetails.mobile }}</em></td>
											<td><i>微信</i><em>{{ contactdetails.wechat }}</em></td>
										</tr>
										<tr>
											<td><i>QQ</i><em>{{ contactdetails.qq }}</em></td>
											<td><i>邮箱</i><em>{{ contactdetails.email }}</em></td>
										</tr>
										<tr>
											<td colspan="2"><i>备注</i><em>{{ contactdetails.remark }}</em></td>
										</tr>
									</table>
									<p class="pr-10"><el-button class="fr" type="primary" size="small"
											@click="contactEdit">修改</el-button></p>

								</div>
							</div>
							<div class="contacts whitebox" v-show="cnav">
								<div class="oh">
									<h3 class="fl">联系人</h3>
									<div class="fr mr-4 mt-2"><el-button type="primary"
											@click="contactframe = true">添加联系人</el-button></div>
									<!-- <span class="fr add" @click="contactframe = true">添加</span> -->
								</div>
								<div class="contacts_list oh">
									<ul class="contacts_list_ul">
										<!-- <li v-for="(item,i) in contactlist" @click="getcontactdetail(item.id);contactnav=i" :class="contactnav==i?'curlibg':''" >{{item.contactName}}</li> -->
										<li v-for="(item, i) in contactlist"
											@click="getcontactdetail(item.id); contactnav = i" :key="item.id"
											:class="contactnav == i ? 'curlibg' : ''">{{ item.contactName }}</li>
									</ul>
									<table border="0" cellspacing="0" cellpadding="0" class="fl">
										<tr>
											<td><i>姓名</i><em>{{ contactlist[0].contactName }}</em></td>
											<td><i>性别</i><em><span v-if="contactlist[0].gender == 1">男</span><span
														v-if="contactlist[0].gender == 2">女</span><span
														v-if="contactlist[0].gender == 0"></span></em></td>
										</tr>
										<tr>
											<td><i>部门</i><em>{{ dname(contactlist[0].departmentId) }}</em></td>
											<td><i>职位</i><em>{{ contactlist[0].position }}</em></td>
										</tr>
										<tr>
											<td><i>手机</i><em>{{ contactlist[0].mobile }}</em></td>
											<td><i>微信</i><em>{{ contactlist[0].wechat }}</em></td>
										</tr>
										<tr>
											<td><i>QQ</i><em>{{ contactlist[0].qq }}</em></td>
											<td><i>邮箱</i><em>{{ contactlist[0].email }}</em></td>
										</tr>
										<tr>
											<td colspan="2"><i>备注</i><em>{{ contactlist[0].remark }}</em></td>
										</tr>
									</table>

								</div>
							</div>
							<!-- 添加联系人弹框 -->
							<div class="framebgbox" v-show="contactframe">
								<div class="framebox">
									<div class="frame">
										<h4>{{ contactTyep == 'edit' ? '修改' : '添加' }}联系人</h4>
										<div class="projectMane_labelbox_pop projectMane_labelbox_popmany">
											<div class="oh">
												<h5 class="title labelfl fl"><em class="redfont">*</em>姓 名</h5>
												<div class="labelfr fl"><el-input v-model="contactName"
														placeholder="请输入" class="inp_text"></el-input></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">手 机</h5>
												<div class="labelfr fl"><el-input v-model="mobile" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">性 别</h5>
												<div class="labelfr fl"><el-select v-model="sexvalue" placeholder="请选择"
														@change="sexChange"><el-option v-for="item in sexoptions"
															:key="item.value" :label="item.label" :value="item.value">{{
																item.label }}</el-option></el-select>
												</div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">部 门</h5>
												<div class="labelfr fl">
													<el-input v-model="dvalue" placeholder="请输入"
														class="inp_text"></el-input>
													<!-- <el-select v-model="dvalue" placeholder="请选择">
														<el-option v-for="item in doptions"
														:key="item.value"
														:label="item.label" 
														:value="item.value">
														{{item.label }}
														</el-option>
													</el-select> -->
												</div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">职 位</h5>
												<div class="labelfr fl"> <el-input v-model="position" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">微 信</h5>
												<div class="labelfr fl"><el-input v-model="weixin" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">Q Q</h5>
												<div class="labelfr fl"><el-input v-model="qq" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh">
												<h5 class="title labelfl fl">邮 箱</h5>
												<div class="labelfr fl"><el-input v-model="email" placeholder="请输入"
														class="inp_text"></el-input></div>
											</div>
											<div class="oh remarkline">
												<h5 class="title labelfl fl">备 注</h5>
												<div class="labelfr fl"><textarea v-model="contactremark"></textarea>
												</div>
											</div>
											<div class="oh" v-show="erromsg.length > 0">
												<h5 class="title labelfl fl"></h5>
												<div class="labelfr fl">
													<p class="errortips redfont">{{ erromsg }}</p>
												</div>
											</div>
											<div class="oh btnbox">
												<span class="basebtn fl" @click="addcontact()">确定</span> <span
													class="graybtn fr" @click="contactframe = false">取消</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- 弹框end -->
							<!-- 联系人结束 -->
						</div>
					</div>

					<!-- 中 结束 -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import addProject from "./inc/addProject.vue";
export default {
	name: 'workbenchEnterpriseDetails',
	components: { addProject },
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse']),

	},
	data() {
		return {
			title: "工作台企业详情",
			newestlist: [], //最新记录
			tracklist: [], //跟进列表
			title: "",
			newestlist: [{ createTime: "", contactTime: " ", todoTime: '', trackStatus: "", managerName: "", remark: "" }],//最新纪录
			newtodoTime: '',//最新跟进时间
			todolist: [],//待办列表  
			userdata: {},
			leaderpagetype: 2,
			erromsg: '',//弹框错误提示
			state: 1, //存续状态
			follow: 1, //待办纪录还是跟进纪录表格
			enterpriseid: 0,
			contactnav: 0,
			cnav: true, //默认联系人
			cusid: 0,
			gjframe: false, //添加跟进纪录弹框是否开启
			dbframe: false,//添加待办纪录弹框是否开启
			contactframe: false, //添加联系人弹框
			editdbframe: false,//修改待办纪录弹窗
			editgjframe: false,//修改跟进纪录弹窗
			input: '',
			sexoptions: [{ value: 1, label: '男' }, { value: 2, label: '女' }],
			sexvalue: '',
			doptions: [],
			dvalue: '',
			trackStatusoptions: [{ value: '1', label: 'x' },],
			trackStatusvalue: '',
			addtrackremark: '',
			trackid: '',
			options: [],
			todoTime: '',//添加待办时间
			contactoptions: [],
			contactId: "",
			manageroptins: [],
			managerId: "",
			dbremark: '',
			notifyTime: '',
			todoid: '',
			trackTime: '',
			value: '',
			value1: '',
			cusinfo: {},
			companyinfo: { notionlist: [] },
			realController: [], //实际控制人
			contactlist: [{ address: "", contactName: " ", departmentId: '', email: "", gender: "", id: 6, mobile: "", position: "", qq: "", remark: "", wechat: "" }],
			contactdetails: { contactName: '' },
			contactName: '',
			position: '',
			mobile: '',
			weixin: '',
			qq: '',
			email: '',
			contactremark: '',
			project: {
				name: '',
				summary: '',
				showFileList: true,
				status: '',
				investorName: '',
				district: '',
				industryType: [],
				investmentAmount: '',
				expectedAnnualOutput: '',
				expectedProfit: '',
				expectedEmployment: '',
				demand: '',
				policy: '',
				projectFileList: [], // 项目文件列表
			},

			isDisabled: false,
			projectStatusOptions: [{ value: '1', label: '待处理' }, { value: '2', label: '处理中' }, { value: '3', label: '处理完成' }],
			industryTypeOptions: [{ value: '1', label: '1' }, { value: '2', label: '2' }, { value: '3', label: '3' }],
			contactTyep: 'add',
			temDialogText : '',
			isInitiate: false,//发起备注详情弹框
			pushLogs: [],//推送记录
		}
	},
	beforeCreate() {
		this.todolist = [{ todoTime: '' }];
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		this.getParameter();
	},
	mounted() {
		this.userdata = this.getuseriformation();
		console.log('id', this.$route.query.id)
		this.cusid = this.$route.query.id;
		// this.enterpriseid = this.$route.query.code; 
		// console.log('1111',this.enterpriseid);
		this.getcusdetail();
		this.getProjectClass();
		this.getStausType();
		this.getHour('2025-09-05 00:00:00', '2025-09-04 11:24:28');
		
	},
	methods: {
		getPushLogs() {
			let that = this;
			let ajaxurl = this.$api.crm.pushLog.detail()+"?id="+this.cusid;
			this.$axios.get(ajaxurl, {
                headers: {
                    AuthToken: this.userdata.token
                },
            }).then((res) => {
                if (res.data.success) {
                    console.log('推送记录',res);
					that.pushLogs = res.data.data;
                }
            })

		},
		//跟进和待办展开备注
		initiatePopup(text) {
			 this.temDialogText = text;
			this.isInitiate = true;
		},
		//项目撤回	
		rollbackCustomer() {
			let that = this;
			let ajaxurl = this.$api.crm.push.Rollback();
			//确认框
			this.$confirm('确认撤回项目 ？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				$.ajax({
					type: "post",
					url: ajaxurl,
					headers: {
						AuthToken: this.userdata.token
					},
					data: { customerId: this.cusid },
					success: function (res) {
						if (res.success) {
							that.$message({
								message: '撤回成功',
								type: 'success'
							})
						} else {
							that.$message.error(res.msg);
						}
					},
				})
			})
		
		},
		//一键退回
		deselectCustomer() {
			let that = this;
			let ajaxurl = this.$api.crm.push.Deselect();
			//确认框
			this.$confirm(this.cusinfo.projectType == 3 ? '确认一键退回 共享项目池 ？' : '确认一键退回 项目推荐人 ？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				$.ajax({
					type: "post",
					url: ajaxurl,
					headers: {
						AuthToken: this.userdata.token
					},
					data: { customerId: this.cusid },
					success: function (res) {
						if (res.success) {
							that.$message({
								message: '退回成功',
								type: 'success'
							})
						} else {
							that.$message.error(res.msg);
						}
					},
				})
			})
		},
		//从共享客户中选入
		SelectCustomer() {
			let that = this;
			let ajaxurl = this.$api.crm.push.Select();
			//确认框
			this.$confirm('确认选入项目？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				$.ajax({
					type: "post",
					url: ajaxurl,
					headers: {
						AuthToken: this.userdata.token
					},
					data: { customerId: this.cusid },
					success: function (res) {
						if (res.success) {
							that.$message({
								message: '保存成功',
								type: 'success'
							})
						}
					}
				})
			}).catch(() => {
			});
		},
		postCusInfo(data) {

		},
		//获取跟进记录详情
		getTrackdetail(trackid) {
			var _this = this;
			this.$axios.get(this.$api.crm.track.detail() + "?trackId=" + trackid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log('跟进纪录详情', res);
				if (res.data.success) {
					_this.trackTime = res.data.contactTime;
					_this.trackStatusvalue = res.data.status;
					_this.contactId = res.data.contactId;
					_this.addtrackremark = res.data.remark;
				} else {
					_this.$message.error(res.data.msg);
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		//获取待办记录详情
		getTododetail(todoid) {
			var _this = this;
			this.$axios.get(this.$api.crm.todo.detail() + "?todoId=" + todoid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log('待办纪录详情', res);
				if (res.data.success) {
					_this.todoTime = res.data.todoTime;
					_this.notifyTime = res.data.notifyTime;
					_this.contactId = res.data.contactId;
					_this.dbremark = res.data.remark;
				} else {
					_this.$message.error(res.data.msg);
				}
			}).catch(function (err) {
				console.log(err);
			});
		},
		contactEdit() {
			console.log('修改联系人', this.contactdetails);
			this.contactframe = true;
			this.contactTyep = 'edit';
			this.contactName = this.contactdetails.contactName;
			this.position = this.contactdetails.position;
			this.dvalue = this.contactdetails.departmentId;
			this.sexvalue = this.contactdetails.gender;
			this.mobile = this.contactdetails.mobile;
			this.weixin = this.contactdetails.wechat;
			this.qq = this.contactdetails.qq;
			this.email = this.contactdetails.email;
			this.contactremark = this.contactdetails.remark;
			this.contactId = this.contactdetails.id;
		},

		//传入id，匹配部门名称
		dname(id) {
			let res = '';
			this.doptions.forEach(item => {
				if (item.id == id) {
					res = item.name;
				}
			});
			return res;
		},
		sexChange(value) {
			console.log(value);
		},
		handleChange(value) {
			console.log(value);
		},
		// 获取项目产业类型
		getProjectClass() {
			let _this = this;
			let ajaxurl = this.$api.crm.parameter.projectClass();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					let datalist = res.data.list;
					_this.industryTypeOptions = datalist;
				}
			})
		},
		//获取项目状态类型
		getStausType() {
			let _this = this;
			let ajaxurl = this.$api.crm.parameter.projectStatus();
			this.$axios.get(ajaxurl, {
				headers: {
					AuthToken: this.userdata.token
				}
			}).then(function (res) {
				if (res.data.success) {
					let datalist = res.data.list;
					_this.projectStatusOptions = datalist;
				}
			})
		},
		trackStatusTurnLabel(value) {
			//对比值，返回对应的label
			let res = '';
			this.trackStatusoptions.forEach(item => {
				if (item.value == value) {
					res = item.label;
				}
			})
			return res
		},
		handleOpenURL(url) {
			// 打开新窗口
			window.open(url, '_blank');
		},
		//删除项目附件
		deleteFile(id) {
			return new Promise((resolve, reject) => {
				this.$axios.post(this.$api.crm.customer.deleteFile(), { id: id }, {
					headers: {
						'AuthToken': this.userdata.token // 自定义请求头，传递 Token
					}
				}).then((res) => {
					if (res.data.success) {
						this.$message.success('删除成功！');
						resolve(true);
					} else {
						this.$message.error(res.data.msg);
						reject(false);
					}

				})
			});


		},
		open() { //删除企业提示
			var _this = this;
			this.$confirm('此操作降删除该记录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message(
					this.deletetodofun(this.todoid),
					{
						type: 'success',
						message: '删除成功!',
					});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		open2() { //删除企业提示
			var _this = this;
			this.$confirm('此操作降删除该记录, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$message(
					this.deletetrackfun(this.trackid),
					{
						type: 'success',
						message: '删除成功!',
					});
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		//客户详情
		getcusdetail() {
			this.bus.$emit('loading', true);
			var _this = this;
			console.log('客户详情id', _this.cusid);
			this.$axios.get(this.$api.crm.customer.detail() + "?id=" + _this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("客户详情", res);
				if (res.data.success) {
					_this.cusinfo = res.data.data;
					_this.enterpriseid = res.data.data.stockCode;
					document.title = res.data.data.customerName;
					_this.title = res.data.data.customerName;
					_this.project.name = res.data.data.project;
					_this.project.summary = res.data.data.summary;
					_this.project.fileName = res.data.data.file;
					_this.project.projectFileList = res.data.data.fileList;
					_this.project.status = res.data.data.status || "";
					_this.project.industryType = [res.data.data.bigClass, res.data.data.smallClass];
					_this.project.investmentAmount = res.data.data.amount || "";
					_this.project.expectedAnnualOutput = res.data.data.outputValue || "";
					_this.project.expectedProfit = res.data.data.profit || "";
					_this.project.expectedEmployment = res.data.data.employment || "";
					_this.project.demand = res.data.data.landing;
					_this.project.policy = res.data.data.policy;
					_this.project.investorName = res.data.data.investor;
					_this.project.customerName = res.data.data.customerName;

					_this.project.projectFileList.forEach(item => {
						item.name = item.title;
					});
					console.log('enterpriseid', _this.enterpriseid)
					if (res.data.data.stockCode) {
						_this.getcusinfo(); //获取企业信息第一部分
						_this.getcusinfo2();//获取企业信息第二部分
					}
					_this.gettodolist(); //获取待办列表
					_this.gettracklist(); //获取跟进列表
					if (res.data.data.contactList.length > 0) {
						_this.contactlist = res.data.data.contactList;
						_this.contactoptions = _this.contactlist;
					}
					_this.getdepartmentlist();
					_this.bus.$emit('loading', false);
				}
				else {
					if (res.data.msg == '没有权限') {
						_this.$message({
							type: 'warning',
							message: res.data.msg,
						});
						this.bus.$emit('loading', false);
					}

				}
			}).catch(function (error) {
				_this.bus.$emit('loading', false);
				// 请求失败处理 console.log(error);
			});
		},
		//获取企业基本信息第一部分
		getcusinfo() {
			// this.bus.$emit('loading', true);
			var _this = this;
			this.$axios.get(this.$api.cyl.enterprise.detail() + "?stockCode=" + _this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("企业基本信息", res);
				if (res.data.code < 1) {

					_this.companyinfo = res.data.data.baseinfo;
					_this.companyinfo.notionlist = _this.taglistfun(_this.companyinfo.notion, _this.companyinfo.notionCode);
					_this.companyinfo.taglist = _this.taglistfun(_this.companyinfo.tag, _this.companyinfo.tagCode);

					// console.log('title',_this.companyinfo.notionlist,_this.companyinfo.taglist);
					// _this.bus.$emit('loading', false);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取企业信息第二部分
		getcusinfo2() {
			this.bus.$emit('loading', true);
			var _this = this;
			this.$axios.get(this.$api.cyl.enterprise.detail2() + "?stockCode=" + _this.enterpriseid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("企业基本信息2", res);
				if (res.data.code < 1) {
					_this.realController = res.data.data.realController || [];//实际控制人 
					// _this.bus.$emit('loading', false);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//联系人详情
		getcontactdetail(contactid) {
			var _this = this;
			this.$axios.get(this.$api.crm.contact.detail() + "?contactId=" + contactid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("联系人详情", res);
				if (res.data.code < 1) {
					_this.cnav = false;
					_this.contactdetails = res.data.data;
					console.log("11", _this.contactdetails);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//添加联系人
		addcontact() {
			var _this = this;
			console.log(this.contactName, this.sexvalue, this.dvalue, this.position, this.mobile, this.weixin, this.qq, this.email, this.contactremark);
			// ||this.sexvalue==''||this.dvalue==''||this.position==''||this.weixin==''||this.qq==''||this.email==''
			if (this.contactName == '') {
				this.erromsg = '姓名不得为空';
				return;
			}
			var sdgs = {
				contactId: _this.contactTyep == 'edit' ? _this.contactId : 0,
				customerId: _this.cusid,
				contactName: _this.contactName,
				// mobile:_this.mobile,
			};
			if (_this.mobile.length > 10) {
				sdgs.mobile = _this.mobile;
			}
			if (_this.sexvalue) {
				sdgs.gender = _this.sexvalue;
			}
			if (_this.dvalue) {
				sdgs.departmentName = _this.dvalue;
			}
			if (_this.weixin.length > 0) {
				sdgs.weixin = _this.weixin;
			}
			if (_this.position.length > 0) {
				sdgs.position = _this.position;
			}
			if (_this.qq.length > 0) {
				sdgs.qq = _this.qq;
			}
			if (_this.email.length > 0) {
				sdgs.email = _this.email;
			}
			if (_this.contactremark.length > 0) {
				sdgs.remark = _this.contactremark;
			}
			console.log(sdgs);
			$.ajax({
				type: "POST",
				url: this.$api.crm.contact.post(),
				data: sdgs,
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.contactframe = false;
						if (_this.contactTyep == 'add') {
							_this.getcusdetail();
						} else {
							_this.getcontactdetail(_this.contactId);

						}
						_this.$message({
							type: 'success',
							message: '保存成功',

						})
					} else {
						_this.erromsg = res.msg;
					}
				}
			})
		},
		//获取部门列表
		getdepartmentlist() {
			var _this = this;
			// this.bus.$emit('loading', true);  
			this.$axios.get(this.$api.crm.department.list(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("部门列表", res);
				if (res.data.success) {
					var ndepartmentlist = res.data.list;
					for (var i = 0; i < ndepartmentlist.length; i++) {
						ndepartmentlist[i].label = ndepartmentlist[i].name;
						ndepartmentlist[i].value = ndepartmentlist[i].id;
					}
					_this.doptions = ndepartmentlist;
					// console.log('1111',_this.doptions);
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取跟进列表
		gettracklist() {
			var _this = this;
			this.$axios.get(this.$api.crm.track.list() + "?customerId=" + _this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("客户跟进列表", res);
				if (res.data.code < 1) {
					_this.tracklist = res.data.list;
					// _this.turndata(_this.tracklist);
					console.log('genj	', _this.tracklist);
					if (_this.tracklist.length > 0) {
						_this.newestlist = _this.tracklist;
						console.log('1123123', _this.newestlist);
					}
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取待办列表
		gettodolist() {
			var _this = this;
			this.$axios.get(this.$api.crm.todo.list() + "?customerId=" + _this.cusid, { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("待办列表", res);
				if (res.data.code < 1) {
					_this.todolist = res.data.list;
					// _this.getHour(res.data.list.todoTime,res.data.list.notifyTime);
					for (var i = 0; i < _this.todolist.length; i++) {
						// console.log(_this.todolist[i].todoTime,_this.todolist[i].notifyTime);
						_this.todolist[i].notifyTime = _this.getHour(_this.todolist[i].todoTime, _this.todolist[i].notifyTime);
					}

					if (_this.todolist.length > 0) {
						_this.newtodoTime = _this.todolist[0].todoTime;
					}
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//格式化日期 （时间戳）
		dateFormat(type, date) {
			var M = date.getMonth() + 1;
			M = M < 10 ? ('0' + M) : M;
			var y = date.getFullYear();
			var d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			var h = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
			var m = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
			var s = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
			var time = y + '-' + M + '-' + d + ' ' + h + ':' + m + ':' + s;
			if (type == 1) {
				this.todoTime = time;
			}
			if (type == 2) {
				this.notifyTime = time;
			}
			if (type == 3) {
				this.trackTime = time;
			}
			console.log(time);
			return time;
		},

		getHour(startTime, endTime) {
			// 将时间字符串转换为 Date 对象
			const start = new Date(startTime);
			const end = new Date(endTime);

			// 计算时间差（毫秒）
			const diffMs = start - end;

			// 转换为小时
			const diffHours = diffMs / (1000 * 60 * 60);
			// console.log(diffHours);
			// 返回小时差值（保留两位小数）
			return diffHours.toFixed(2);
		},
		//获取负责人列表 
		getmangerlist() {
			var _this = this;
			// this.bus.$emit('loading', true);  
			this.$axios.get(this.$api.crm.user.list(), { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("用户列表", res);
				if (res.data.success) {
					_this.manageroptins = res.data.list;
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},

		//修改或添加待办列表
		addtodofun(todoId, cusid) {
			console.log(todoId, cusid);
			console.log('错误信息', this.erromsg);
			console.log(this.todoTime, this.notifyTime, this.contactId, this.managerId, this.dbremark);
			var _this = this;
			if (this.todoTime == '' || this.notifyTime == '') {
				this.erromsg = "列表不能为空";
			}
			if (this.contactId == '') {
				this.contactId = 0;
			}
			$.ajax({
				type: "POST",
				url: this.$api.crm.todo.post(),
				data: { todoId: todoId, customerId: cusid, todoTime: _this.todoTime, notifyTime: _this.notifyTime, contactId: _this.contactId, remark: _this.dbremark, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					// console.log()
					console.log(res);
					if (res.success) {
						_this.dbframe = false;
						_this.editdbframe = false;
						_this.gettodolist();
					} else {
						_this.erromsg = res.msg;
					}
				}
			})
		},
		//删除待办纪录
		deletetodofun(id) {
			var _this = this;
			$.ajax({
				type: "POST",
				url: this.$api.crm.todo.delete(),
				data: { todoId: id, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					// console.log()
					console.log(res);
					if (res.success) {
						_this.gettodolist();
					}
				}
			})
		},
		//获取跟进状态分类
		getParameter() {
			var _this = this;
			this.$axios.get(this.$api.crm.parameter.list() + "?type=4", { headers: { AuthToken: this.userdata.token } }).then(function (res) {
				console.log("分类状态", res);
				if (res.data.success) {
					_this.trackStatusoptions = res.data.list;
				}
				else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//修改或添加跟进列表
		addtrackfun(trackId, cusid) {
			console.log(trackId, cusid)
			console.log(this.trackTime, this.trackStatusvalue, this.contactId, this.addtrackremark);
			var _this = this;
			if (this.contactId == '') {
				this.contactId = 0;
			}
			if (this.todoTime == '' || this.notifyTime == '') {
				this.erromsg = "列表不能为空";
			}
			$.ajax({
				type: "POST",
				url: this.$api.crm.track.post(),
				data: { trackId: trackId, customerId: cusid, trackTime: _this.trackTime, trackStatus: _this.trackStatusvalue, contactId: _this.contactId, remark: _this.addtrackremark, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.gjframe = false;
						_this.editgjframe = false;
						_this.gettracklist();
					}
				}
			})
		},
		//删除待办纪录
		deletetrackfun(id) {
			var _this = this;
			$.ajax({
				type: "POST",
				url: this.$api.crm.track.delete(),
				data: { trackId: id, },
				headers: { AuthToken: this.userdata.token },
				success: function (res) {
					console.log(res);
					if (res.success) {
						_this.gettracklist();
					} else {
						_this.$message({
							type: 'error',
							message: res.msg,
						});
						// alert(res.msg);
					}
				}
			})
		},
	}
}
</script>

<style lang="scss" scoped>
.summary-td{
    // width: 100%;
    height: 70px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;           //特别显示模式
    -webkit-line-clamp: 1;          //行数
    line-clamp: 1;                  
    -webkit-box-orient: vertical;   //盒子中内容竖直排列 
    line-height: 70px;
 }
::v-deep {
	.framebgbox {

		.inp_text {
			font-size: 16px;
			width: 116%;
			margin-left: 20px;
		}

		.el-select {
			width: 121%;
			margin-left: 20px;
		}

		.el-date-editor {
			width: 121%;
			margin-left: 20px;
		}

		textarea {
			width: 121%;
			margin-left: 20px;
		}
	}
}

.projectMane_labelbox_pop textarea {
	width: 265px;
}

.pr-10 {
	padding-right: 100px;
}

.return-btn {}
</style>
